import { createSelector } from "reselect";

// Basic selectors
const selectAppConfigurations = (state) => state.appConfigurations || {};

export const isFeatureEnabled = (featureName) =>
    createSelector([selectAppConfigurations], (appConfigurations) => {
        if (!Object.keys(appConfigurations).includes(featureName))
            return false;

        return appConfigurations?.[featureName].isEnabled;
    });

// { [orgGuid]: { [name]: { isEnabled } } }, loaded at sign-in when the
// organization filter can apply (see organizationAppConfigurations).
const NO_ORGANIZATION_FLAGS = {};
export const selectOrganizationFlags = (state) =>
    state?.organizationAppConfigurations?.byOrg || NO_ORGANIZATION_FLAGS;
